import bikeLeasing from '@/components/icons/icon-bike-leasing.vue';
import bonus from '@/components/icons/icon-bonus.vue';
import car from '@/components/icons/icon-car.vue';
import daycare from '@/components/icons/icon-daycare.vue';
import disabilityInsurance from '@/components/icons/icon-disability-insurance.vue';
import discount from '@/components/icons/icon-discount.vue';
import events from '@/components/icons/icon-events.vue';
import fitness from '@/components/icons/icon-fitness.vue';
import fitnessMembership from '@/components/icons/icon-fitness-membership.vue';
import homeoffice from '@/components/icons/icon-homeoffice.vue';
import jobticket from '@/components/icons/icon-jobticket.vue';
import location from '@/components/icons/icon-location.vue';
import lunch from '@/components/icons/icon-lunch.vue';
import parking from '@/components/icons/icon-parking.vue';
import pension from '@/components/icons/icon-pension.vue';
import publicTransport from '@/components/icons/icon-public-transport.vue';
import sabbath from '@/components/icons/icon-sabbath.vue';
import salary from '@/components/icons/icon-salary.vue';
import snacks from '@/components/icons/icon-snacks.vue';
import training from '@/components/icons/icon-training.vue';
import vacation from '@/components/icons/icon-vacation.vue';
import workingTime from '@/components/icons/icon-working-time.vue';
import workplace from '@/components/icons/icon-workplace.vue';

export default {
  bikeLeasing: {
    component: bikeLeasing
  },
  bonus: {
    component: bonus
  },
  car: {
    component: car
  },
  daycare: {
    component: daycare
  },
  disabilityInsurance: {
    component: disabilityInsurance
  },
  discount: {
    component: discount
  },
  events: {
    component: events
  },
  fitness: {
    component: fitness
  },
  fitnessMembership: {
    component: fitnessMembership
  },
  homeoffice: {
    component: homeoffice
  },
  jobticket: {
    component: jobticket
  },
  location: {
    component: location
  },
  lunch: {
    component: lunch
  },
  parking: {
    component: parking
  },
  pension: {
    component: pension
  },
  publicTransport: {
    component: publicTransport
  },
  subbath: {
    component: sabbath
  },
  salary: {
    component: salary
  },
  snacks: {
    component: snacks
  },
  training: {
    component: training
  },
  vacation: {
    component: vacation
  },
  workingTime: {
    component: workingTime
  },
  workplace: {
    component: workplace
  }
};
